import styled from "styled-components";
import { FooterItemProps } from "./props";

export const FooterSectionContainer = styled.div`
  margin-top: 100px;
  color: var(--subtle);
  padding: 36px 0px 42px;
  border-top: 1px solid var(--line);
  @media (max-width: 768px) {
    margin-top: 48px;
    padding: 28px 0px 32px;
  }
`;

export const FooterSectionContent = styled.div`
  max-width: 1080px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    max-width: 320px;
  }
`;

export const FooterLeft = styled.div`
  @media (max-width: 768px) {
    line-height: 20px;
  }
`;

export const FooterRight = styled.div`
  display: flex;
  flex-direction: row;
  gap: 26px;
  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: repeat(2, max-content);
    gap: 10px 28px;
    width: 100%;
  }
`;

export const FooterItem = styled.div<FooterItemProps>`
  margin-left: ${({ margin }) =>
    margin !== undefined && margin.left !== undefined ? margin.left : 0}px;
  margin-right: ${({ margin }) =>
    margin !== undefined && margin.right !== undefined ? margin.right : 0}px;
  font-size: 14px;
  cursor: pointer;
  a {
    color: var(--subtle);
    text-decoration: none;
    transition: color 0.2s ease;
    &:hover {
      color: var(--heading);
    }
  }
  @media (max-width: 768px) {
    margin: 0px;
    font-size: 13px;
    line-height: 20px;
    margin-left: 0px;
    margin-right: 0px;
  }
`;
